"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitrumsepolia = void 0;
exports.arbitrumsepolia = {
    "addresses": {
        "ProxyAdmin": "0x3b072FEA46117ac64F7B5baa0E60AfF4F966001b",
        "FeedPriceOracle": "0xC7e7987d4C891c355b1b3D684795354Cd2631E1E",
        "Sumer": "0x670075e62ffC470E7B11dB38dD3CCC292EF90F0d",
        "CompoundLens": "0x5F558f2aaE98D166537931F27bD8E0D149bBd700",
        "JumpRate#StableBC": "0x092fa73f599f3CcEa2093d65c9fDcb4A49fa7924",
        "CompLogic": "0xAB1793057D5da7313802620b66bCAD4eaFc73cAf",
        "RedemptionManager": "0xABA53526511a32b2100B33829Af932D0896Fda07",
        "Timelock": "0xD620b1018298e8812065556d1353E5AC36Bcdd2e",
        "Comptroller": "0x38009Ff392C383f7D100946aCc283259acE402FD",
        "sdrUSDC": "0x2aE99fb987D1B6E8890018559030515f66617F39",
        "USDC": "0x75faf114eafb1BDbe2F0316DF893fd58CE46AA4d"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC",
            "ctokenAddr": "0x2aE99fb987D1B6E8890018559030515f66617F39",
            "underlySym": "USDC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x75faf114eafb1BDbe2F0316DF893fd58CE46AA4d",
            "assetGroupId": 1
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#StableBC",
            "contract": "JumpRateModelV2",
            "address": "0x092fa73f599f3CcEa2093d65c9fDcb4A49fa7924",
            "tokens": [
                "USDC"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.09333",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.8"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=arbitrumsepolia.js.map